export const PlayCircle = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M16 4C13.6266 4 11.3066 4.70379 9.33316 6.02236C7.35977 7.34094 5.8217 9.21509 4.91345 11.4078C4.0052 13.6005 3.76756 16.0133 4.23058 18.3411C4.6936 20.6689 5.83649 22.8071 7.51472 24.4853C9.19295 26.1635 11.3312 27.3064 13.6589 27.7694C15.9867 28.2324 18.3995 27.9948 20.5922 27.0866C22.7849 26.1783 24.6591 24.6402 25.9776 22.6668C27.2962 20.6935 28 18.3734 28 16C28 14.4241 27.6896 12.8637 27.0866 11.4078C26.4835 9.95189 25.5996 8.62901 24.4853 7.51471C23.371 6.40041 22.0481 5.51649 20.5922 4.91344C19.1363 4.31038 17.5759 4 16 4ZM14 20V12L20 16L14 20Z"
      fill="#FF6636"
    />
    <path
      d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
      stroke="#FF6636"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M20 16L14 12V20L20 16Z"
      stroke="#FF6636"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const BookOpen = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M7 5.00098H25C25.2652 5.00098 25.5196 5.10633 25.7071 5.29387C25.8946 5.48141 26 5.73576 26 6.00098V25.001C26 25.7966 25.6839 26.5597 25.1213 27.1223C24.5587 27.6849 23.7956 28.001 23 28.001H9C8.20435 28.001 7.44129 27.6849 6.87868 27.1223C6.31607 26.5597 6 25.7966 6 25.001V6.00098C6 5.73576 6.10536 5.48141 6.29289 5.29387C6.48043 5.10633 6.73478 5.00098 7 5.00098Z"
      fill="#23BD33"
    />
    <path
      d="M12 16.001H20"
      stroke="#23BD33"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 20.001H20"
      stroke="#23BD33"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 5.00098H25C25.2652 5.00098 25.5196 5.10633 25.7071 5.29387C25.8946 5.48141 26 5.73576 26 6.00098V25.001C26 25.7966 25.6839 26.5597 25.1213 27.1223C24.5587 27.6849 23.7956 28.001 23 28.001H9C8.20435 28.001 7.44129 27.6849 6.87868 27.1223C6.31607 26.5597 6 25.7966 6 25.001V6.00098C6 5.73576 6.10536 5.48141 6.29289 5.29387C6.48043 5.10633 6.73478 5.00098 7 5.00098Z"
      stroke="#23BD33"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 3.00098V7.00098"
      stroke="#23BD33"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 3.00098V7.00098"
      stroke="#23BD33"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22 3.00098V7.00098"
      stroke="#23BD33"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Trophy = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M7 7V13.887C7 18.8496 10.9693 22.963 15.9318 22.9997C17.1194 23.0088 18.297 22.7826 19.3968 22.3344C20.4966 21.8861 21.4968 21.2246 22.3398 20.388C23.1828 19.5514 23.8518 18.5563 24.3084 17.4599C24.7649 16.3635 25 15.1876 25 14V7C25 6.73478 24.8946 6.48043 24.7071 6.29289C24.5196 6.10536 24.2652 6 24 6H8C7.73478 6 7.48043 6.10536 7.29289 6.29289C7.10536 6.48043 7 6.73478 7 7Z"
      fill="#23BD33"
    />
    <path
      d="M7 7V13.887C7 18.8496 10.9693 22.963 15.9318 22.9997C17.1194 23.0088 18.297 22.7826 19.3968 22.3344C20.4966 21.8861 21.4968 21.2246 22.3398 20.388C23.1828 19.5514 23.8518 18.5563 24.3084 17.4599C24.7649 16.3635 25 15.1876 25 14V7C25 6.73478 24.8946 6.48043 24.7071 6.29289C24.5196 6.10536 24.2652 6 24 6H8C7.73478 6 7.48043 6.10536 7.29289 6.29289C7.10536 6.48043 7 6.73478 7 7Z"
      stroke="#23BD33"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 28H20"
      stroke="#23BD33"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 23V28"
      stroke="#23BD33"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.7734 16H25.9965C27.0574 16 28.0748 15.5786 28.8249 14.8284C29.5751 14.0783 29.9965 13.0609 29.9965 12V10C29.9965 9.73478 29.8911 9.48043 29.7036 9.29289C29.5161 9.10536 29.2617 9 28.9965 9H24.9965"
      stroke="#23BD33"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.24576 16H5.98438C4.92351 16 3.90609 15.5786 3.15595 14.8284C2.4058 14.0783 1.98438 13.0609 1.98438 12V10C1.98438 9.73478 2.08973 9.48043 2.27727 9.29289C2.4648 9.10536 2.71916 9 2.98438 9H6.98438"
      stroke="#23BD33"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Users = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M16 4C13.5726 4.00002 11.2022 4.73622 9.20189 6.11139C7.20156 7.48656 5.66531 9.43604 4.79597 11.7025C3.92662 13.9689 3.76506 16.4457 4.33261 18.8058C4.90015 21.166 6.17013 23.2985 7.97486 24.9219V24.9217C8.72778 23.4405 9.87609 22.1966 11.2926 21.3279C12.709 20.4592 14.3384 19.9996 16 20C15.0111 20 14.0444 19.7068 13.2222 19.1573C12.3999 18.6079 11.759 17.827 11.3806 16.9134C11.0022 15.9998 10.9031 14.9945 11.0961 14.0245C11.289 13.0546 11.7652 12.1637 12.4645 11.4645C13.1637 10.7652 14.0546 10.289 15.0246 10.0961C15.9945 9.90315 16.9998 10.0022 17.9134 10.3806C18.8271 10.759 19.6079 11.3999 20.1574 12.2221C20.7068 13.0444 21 14.0111 21 15C21 16.3261 20.4732 17.5978 19.5355 18.5355C18.5979 19.4732 17.3261 20 16 20C17.6616 19.9996 19.291 20.4592 20.7074 21.3279C22.1239 22.1966 23.2722 23.4405 24.0251 24.9217C25.8299 23.2984 27.0998 21.1658 27.6674 18.8057C28.2349 16.4456 28.0734 13.9688 27.204 11.7024C26.3347 9.43597 24.7984 7.4865 22.7981 6.11134C20.7978 4.73618 18.4274 4.00001 16 4V4Z"
      fill="#E34444"
    />
    <path
      d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
      stroke="#E34444"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M16 20C18.7614 20 21 17.7614 21 15C21 12.2386 18.7614 10 16 10C13.2386 10 11 12.2386 11 15C11 17.7614 13.2386 20 16 20Z"
      stroke="#E34444"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M7.97656 24.9218C8.72983 23.4408 9.87821 22.1971 11.2946 21.3284C12.711 20.4598 14.3401 20 16.0017 20C17.6632 20 19.2923 20.4598 20.7087 21.3284C22.1251 22.1971 23.2735 23.4407 24.0268 24.9217"
      stroke="#E34444"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Calender = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.08156 1.33366V2.66699H9.92156V1.33366H11.2016V2.66699H13.7616C13.9408 2.66699 14.0922 2.73144 14.216 2.86033C14.3397 2.98921 14.4016 3.14699 14.4016 3.33366V14.0003C14.4016 14.187 14.3397 14.3448 14.216 14.4737C14.0922 14.6025 13.9408 14.667 13.7616 14.667H2.24156C2.06236 14.667 1.9109 14.6025 1.78716 14.4737C1.66343 14.3448 1.60156 14.187 1.60156 14.0003V3.33366C1.60156 3.14699 1.66343 2.98921 1.78716 2.86033C1.9109 2.73144 2.06236 2.66699 2.24156 2.66699H4.80156V1.33366H6.08156ZM13.1216 7.33366H2.88156V13.3337H13.1216V7.33366ZM9.94716 8.09366L10.8432 9.04033L7.68156 12.3337L5.41596 9.97366L6.32476 9.04033L7.68156 10.4537L9.94716 8.09366ZM4.80156 4.00033H2.88156V6.00033H13.1216V4.00033H11.2016V4.66699H9.92156V4.00033H6.08156V4.66699H4.80156V4.00033Z"
      fill="white"
    />
  </svg>
);

export const Edit = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4737 3.00412C16.6407 3.01912 16.7137 3.22312 16.5937 3.34212L8.2737 11.6621C8.17971 11.7562 8.11241 11.8735 8.0787 12.0021L7.0787 15.8321C7.04569 15.9587 7.04636 16.0917 7.08063 16.2179C7.11491 16.3442 7.1816 16.4592 7.27409 16.5517C7.36659 16.6442 7.48166 16.7109 7.60789 16.7452C7.73413 16.7795 7.86713 16.7801 7.9937 16.7471L11.8227 15.7471C11.9514 15.7131 12.0688 15.6455 12.1627 15.5511L20.6007 7.11312C20.6271 7.08602 20.6607 7.06705 20.6976 7.05846C20.7344 7.04986 20.7729 7.052 20.8086 7.06463C20.8443 7.07725 20.8756 7.09983 20.8988 7.12969C20.922 7.15956 20.9362 7.19545 20.9397 7.23312C21.2909 10.5827 21.2708 13.9609 20.8797 17.3061C20.6567 19.2111 19.1257 20.7061 17.2277 20.9191C13.7513 21.3043 10.2431 21.3043 6.7667 20.9191C4.8677 20.7061 3.3367 19.2111 3.1137 17.3061C2.70168 13.7811 2.70168 10.2201 3.1137 6.69512C3.3367 4.78912 4.8677 3.29412 6.7667 3.08212C9.99121 2.7247 13.2439 2.69856 16.4737 3.00412Z"
      fill="#089BC4"
    />
    <path
      d="M17.8192 4.23702C17.8424 4.21374 17.87 4.19527 17.9004 4.18266C17.9308 4.17006 17.9633 4.16357 17.9962 4.16357C18.0291 4.16357 18.0617 4.17006 18.092 4.18266C18.1224 4.19527 18.15 4.21374 18.1732 4.23702L19.5872 5.65202C19.6339 5.69888 19.6602 5.76235 19.6602 5.82852C19.6602 5.89469 19.6339 5.95816 19.5872 6.00502L11.2942 14.3C11.2627 14.3315 11.2233 14.3539 11.1802 14.365L9.26622 14.865C9.22403 14.876 9.17969 14.8758 9.13761 14.8644C9.09554 14.853 9.05718 14.8307 9.02635 14.7999C8.99552 14.7691 8.97329 14.7307 8.96186 14.6886C8.95044 14.6465 8.95021 14.6022 8.96122 14.56L9.46122 12.646C9.47235 12.6029 9.49479 12.5636 9.52622 12.532L17.8192 4.23702Z"
      fill="#089BC4"
    />
  </svg>
);

export const Eye = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0583 8.74412C17.2989 9.08137 17.4193 9.25079 17.4193 9.50016C17.4193 9.75033 17.2989 9.91895 17.0583 10.2562C15.9769 11.773 13.2147 15.0418 9.5026 15.0418C5.78969 15.0418 3.02835 11.7722 1.94694 10.2562C1.70627 9.91895 1.58594 9.74954 1.58594 9.50016C1.58594 9.25 1.70627 9.08137 1.94694 8.74412C3.02835 7.22729 5.79048 3.9585 9.5026 3.9585C13.2155 3.9585 15.9769 7.22808 17.0583 8.74412Z"
      stroke="#089BC4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.875 9.5C11.875 8.87011 11.6248 8.26602 11.1794 7.82062C10.734 7.37522 10.1299 7.125 9.5 7.125C8.87011 7.125 8.26602 7.37522 7.82062 7.82062C7.37522 8.26602 7.125 8.87011 7.125 9.5C7.125 10.1299 7.37522 10.734 7.82062 11.1794C8.26602 11.6248 8.87011 11.875 9.5 11.875C10.1299 11.875 10.734 11.6248 11.1794 11.1794C11.6248 10.734 11.875 10.1299 11.875 9.5Z"
      stroke="#089BC4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Clock = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2129_5328)">
      <path
        d="M10.9974 21.0832C5.42865 21.0832 0.914062 16.5686 0.914062 10.9998C0.914062 5.43109 5.42865 0.916504 10.9974 0.916504C16.5661 0.916504 21.0807 5.43109 21.0807 10.9998C21.0807 16.5686 16.5661 21.0832 10.9974 21.0832ZM11.9141 5.0415H10.0807V11.3793L13.7474 15.046L15.0436 13.7498L11.9141 10.6203V5.0415Z"
        fill="#089BC4"
      />
    </g>
    <defs>
      <clipPath id="clip0_2129_5328">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ClockBlack = () => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 2.1665C19.7134 2.1665 24.75 7.01659 24.75 12.9998C24.75 18.9831 19.7134 23.8332 13.5 23.8332C7.28663 23.8332 2.25 18.9831 2.25 12.9998C2.25 7.01659 7.28663 2.1665 13.5 2.1665ZM13.5 4.33317C11.1131 4.33317 8.82387 5.24626 7.13604 6.87158C5.44821 8.4969 4.5 10.7013 4.5 12.9998C4.5 15.2984 5.44821 17.5028 7.13604 19.1281C8.82387 20.7534 11.1131 21.6665 13.5 21.6665C15.887 21.6665 18.1761 20.7534 19.864 19.1281C21.5518 17.5028 22.5 15.2984 22.5 12.9998C22.5 10.7013 21.5518 8.4969 19.864 6.87158C18.1761 5.24626 15.887 4.33317 13.5 4.33317ZM13.5 6.49984C13.7756 6.49987 14.0415 6.59729 14.2474 6.77361C14.4533 6.94994 14.5849 7.1929 14.6171 7.45642L14.625 7.58317V12.5513L17.6704 15.4839C17.8721 15.6789 17.9893 15.9405 17.998 16.2156C18.0067 16.4907 17.9064 16.7587 17.7173 16.9651C17.5283 17.1716 17.2648 17.301 16.9802 17.3271C16.6957 17.3532 16.4115 17.274 16.1854 17.1057L16.0796 17.0158L12.7046 13.7658C12.5298 13.5972 12.4175 13.3779 12.3851 13.1418L12.375 12.9998V7.58317C12.375 7.29585 12.4935 7.0203 12.7045 6.81714C12.9155 6.61398 13.2016 6.49984 13.5 6.49984Z"
      fill="black"
    />
  </svg>
);
export const User = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 12.5C12.7614 12.5 15 10.2614 15 7.5C15 4.73858 12.7614 2.5 10 2.5C7.23858 2.5 5 4.73858 5 7.5C5 10.2614 7.23858 12.5 10 12.5Z"
      stroke="#564FFD"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M2.42188 16.8743C3.19028 15.5442 4.29517 14.4398 5.62553 13.672C6.9559 12.9042 8.4649 12.5 10.0009 12.5C11.537 12.5 13.046 12.9043 14.3763 13.6721C15.7067 14.44 16.8116 15.5444 17.5799 16.8744"
      stroke="#564FFD"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const BarChartIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 16.6668V8.3335"
      stroke="#E34444"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 16.6668V3.3335"
      stroke="#E34444"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 16.6668V13.3335"
      stroke="#E34444"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CalenderAvailibility = () => (
  <svg
    width="49"
    height="49"
    viewBox="0 0 49 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2474 2.04199H16.3307V4.08366H12.2474V2.04199ZM32.6641 2.04199H36.7474V4.08366H32.6641V2.04199ZM44.9141 10.2087V8.16699H38.7891V4.08366H36.7474V14.292H32.6641V4.08366H30.6224V8.16699H18.3724V4.08366H16.3307V14.292H12.2474V4.08366H10.2057V8.16699H4.08073V10.2087H2.03906V44.917H4.08073V46.9587H44.9141V44.917H46.9557V10.2087H44.9141ZM42.8724 16.3337V22.4587H36.7474V16.3337H42.8724ZM42.8724 32.667H36.7474V26.542H42.8724V32.667ZM42.8724 42.8753H36.7474V36.7503H42.8724V42.8753ZM6.1224 36.7503H12.2474V42.8753H6.1224V36.7503ZM6.1224 26.542H12.2474V32.667H6.1224V26.542ZM32.6641 32.667H26.5391V26.542H32.6641V32.667ZM22.4557 32.667H16.3307V26.542H22.4557V32.667ZM16.3307 36.7503H22.4557V42.8753H16.3307V36.7503ZM26.5391 36.7503H32.6641V42.8753H26.5391V36.7503ZM32.6641 22.4587H26.5391V16.3337H32.6641V22.4587ZM22.4557 16.3337V22.4587H16.3307V16.3337H22.4557ZM12.2474 22.4587H6.1224V16.3337H12.2474V22.4587Z"
      fill="#0D99FF"
    />
  </svg>
);

export const CalenderSession1 = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <rect width="34" height="34" fill="url(#pattern0_10435_11650)" />
    <defs>
      <pattern
        id="pattern0_10435_11650"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use href="#image0_10435_11650" transform="scale(0.0078125)" />
      </pattern>
      <image
        id="image0_10435_11650"
        width="128"
        height="128"
        preserveAspectRatio="none"
        href="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const CalenderSession2 = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <rect width="28" height="28" fill="url(#pattern0_10435_11632)" />
    <defs>
      <pattern
        id="pattern0_10435_11632"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use href="#image0_10435_11632" transform="scale(0.0078125)" />
      </pattern>
      <image
        id="image0_10435_11632"
        width="128"
        height="128"
        preserveAspectRatio="none"
        href="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const VedioSession1 = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <rect width="34" height="34" fill="url(#pattern0_10435_11641)" />
    <defs>
      <pattern
        id="pattern0_10435_11641"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use href="#image0_10435_11641" transform="scale(0.0078125)" />
      </pattern>
      <image
        id="image0_10435_11641"
        width="128"
        height="128"
        preserveAspectRatio="none"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAJa0lEQVR4Aeydf5BbVRXHz3nb3by0QOuvznTqoKMDVtpRRKplkwB1BqQwKv8IKpUZ2STbMooO/hoF6SLCjOKPAR3aTbI4A9YB/EPUoaA4lpJkqbaDOlgsjDrC2OlM/dVCu3nZ7b7DudmXsptJdpPm5b27757MOXvfTV7eued7PrnJu2leLZCb0QoIAEaXH0AAEAAMV8Dw9GUGEAAMV8Dw9GUGEAAMV8DQ9OtpywxQV8LQVgAwtPD1tAWAuhKGtgKAoYWvpy0A1JUwtBUADC18PW0BoK6Eoa0AYFjhG9MVABoVMawvABhW8MZ0BYBGRQzrCwCGFbwxXQGgURHD+gKAYQVvTFcAaFTEsL4AYEjBW6UpALRSxpD7BQBDCt0qTQGglTKG3L8wAEQYz40P2vniiJ0vFdgfs/Plp8SbaVDaHc+XHrXzpe3xQvkrA/c/fZ7uHLUGYISseK58s10oHyJ0ywC4DQCG2K8EoEvEm2kAlxLAx1ijLUT0bWvaOsAvnOdjheJH+D4trSkAsVzxXHt1qUhI3+NRr2IXO20F8N1I+Es7V35g+X3FN5z2YXr0xLkAeK96RPwTAA6C3PxTAOnT1X48oNtsMAcAe3X5Tu9VH/cvcznSLAVWqdlgaeHpq2fd5+vmQKG8jt+271AzTixX/rmdLz0YK5SGYzv2nNMs0CkA4oXxD/AOX2YX67ECLlmjZ47ufrOfYZblyudzsfdbRM8B0a3AMw4iKdA2I8EO7Ot7gaEYa4w7A8C9u2Lkuj/mAfWxi/VegZVT1sB9foXhV/hnp5H28vHez97KkKG4YcrqP9g/VnxvfacaAPbS5bcDgvanLPVBR6Olj8dzpWu6zYXPMkb4Ff5DPk6MvR17U5+Lj9vbn3m72tk6Y3t5JU8ZX1Id8WAVIIS7u4moig8zp+fQ4W0VLJkeU8+xTi5x1fuETP1KjeD97KWF8fedTtguil8P9yFetNpgIVjaLlKAATfXnb6q0zR9KH4tJAFssQjcd9Z68iccBRDe0Ulgv4rvxVzLAKCs9HlqhNO0r38nxW8rF4Jz+S0AVoDcwlSgLf19L77KGOGs2mmg2hYPSQE+O18ock+K7wUVADwhdG16WXyVswCgVNDUe118lbYAoFTQ0IMovkpbAFAqaOZBFV+lrTMAB3mAdyHhJ4noC7z9HHvkLcjiKzH1BIBgt+PaG5xM8pZKNvFQNZu6h7ffgwCf4EG/yh5J86P4nQqjIwBHnBUrroDhC481JlPJJB8mC9bz/QfYI2VhFF8JqCMAv4Fr1k2qwTXz6lDyBSd24oP82E72SFhYxVfiaQgAFdXA5vXrP3yC3xI2E+CNvF9LWPgx/Y2Avw3EbWENVD8AyGq7oNVMYrtFmGTxXmJfrDYQ5sD1A6BDNSayiX0DaF0ACI93+FTZnRVY9ABwDvBKevB/zlBCfa9+G/dddrE2FYgEALVcEYk/F9xBAFdw/9/sYm0oEB0AvGSrmeSTCEsu4O4z7MbY6SYaOQCUEJXMhn/xQtIlCHSv6ou3ViCSANTSHb5wqpJJfR4JruX+cXaxJgpEFwAv2Uo2+YjrWuuB4HnvLmlmKRB5AFSuk8ODBx37hPrp209VX/x1BYwAoJbuzOrhdYTwOe7zyQL/FQNzAPCKXU0nfwREt3ld4xvjAFAVd7Kpb3H7MrvxZiQAXtVLXruom24HbzIA3WoXieebDID6FjESRewmCSMBsHPFW1m0s9mNN+MAUFfTAMRvGl95TwBzAHjg18vsfGknLw2rq2mgl7/xjREADIyOr7GdZX/gan+KXWyWApEHQF2Hx7LcfSDXQJpV9tc3owvA6P7+eL54Dy/9PszpnsEeKfMrmUgCEM/vfattOXsI8Ca/hIrqcSIHQCxfuozg5LNcsIvYxRZQIDoAECF/yv8Gf7x/gnN+C7tYGwpEAoCzCuNvtMfKj3G+6vw+EjlxLoHYohdraa68fpLcZ4FgUyCKRSyIfgCg2/YvZWL58lYXSX2r97ZFXJe2fwnVixz1AwAwtWCiM6t6P0EgdcHltoFZ8Lhh7IDwRwC6PYzQKqaGAMDl8MhfWhY1NlZ6l11d9nse/HXskTAnkxppFwK/E9YRgJX20aNPwOj+5Y3JxvOla9GFfXz/WvZIWVgQ6AgA8LLtRl7I2cundV+P5Uqb7FzpLt7+GwE8BABnskfSwoBATwBmyruGmzsRYRcD8TXeNuKaxkFDoDMAXHMzLUgIBABNGQsKAgFAUwDUsIKAQABQSmvsvYZAAAi7+AR8cjP/IBQEvVonsDj60fnDy6M9VqAt/XsCAcErFi+nHu5xgnL4eRWgtvX3HQKEFxkA6+/zjk8e7K0CBP/oJIDPEBzgtwD3V50MQPb1VwHL6lP/jqGjg/oFAQLssJactB7l6NPsYsEr8PJEepC/Dew8sA8Q/K6SSe61jm9NHAHE73Y+BHlGtwogQVf/WXcXEByGk31DavyW+uNMHNvGJyNyDR0I8oY/U9cv6jaigoAQtvBxjrO3Y/+dtmiTs/Wif6qdawDATVdW0bI+w3fIWwGLEIAd6Xcn1YWuFwzVzg7VdHKUZ/F1vO9v2VsZrzjg/f3u1JqpodSf6zvNAMC9SnpQ/XTqbt4U67ECFrrDrw5v/I+fYZx04iUnk7zMsmC9NyMU+PhPEsEPgGAzuXiOk00MNcY9BQDvDM6hxC1I+EXerrCL+a/AYUL66ET6YvXB2/+j8xEnhpL71YzAMGTYL69mkzc72eTO6nCi6en+HABgBN1KNvF9Ijqflx7HQW7+KUD4YGyK1lbTKa1Ou+cC4KVbzaZedA4lU95s0PZKlfd0aeYoQH9Vr3qefq8/dmPq/3Me0qDTFIDauLzZgN9bViNZCZ4R1L9cHePHdgHgHvFmGsBTvLjyC+AFFkT8qtvnrnUyqfN0e9Xz+E5ZawDquyBSJTs4zomMOJlkmv0qJ5O4VLyZBsmNvLhyNWu0tZJOfGfyhou1P7VeGIA6CNJGUgEBQNOyBjUsASAopTWNIwBoWpighiUABKW0pnEEAE0LE9SwBICglNY0jgCgaWGCGpYAEJTSmsYRADQrTNDDEQCCVlyzeAKAZgUJejgCQNCKaxZPANCsIEEPRwAIWnHN4gkAmhUk6OEIAEErrlk8AUCTgoQ1DAEgLOU1iSsAaFKIsIYhAISlvCZxBQBNChHWMASAsJTXJK4AoEkhwhqGABCW8prEFQBCLkTY4V8DAAD//3TbwxUAAAAGSURBVAMA124bPb72i+8AAAAASUVORK5CYII="
      />
    </defs>
  </svg>
);
export const VedioSession2 = () => (
  <svg
    width="41"
    height="42"
    viewBox="0 0 41 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <rect width="40.427" height="42" fill="url(#pattern0_10435_11647)" />
    <defs>
      <pattern
        id="pattern0_10435_11647"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          href="#image0_10435_11647"
          transform="matrix(0.00811649 0 0 0.0078125 -0.0194552 0)"
        />
      </pattern>
      <image
        id="image0_10435_11647"
        width="128"
        height="128"
        preserveAspectRatio="none"
        href="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const QuizCard1 = () => (
  <svg
    width="20"
    height="28"
    viewBox="0 0 20 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.008 17.5329H16.4V7.53288H3.6V18.6995L5.008 17.5329ZM5.568 19.1995L2 22.1162V6.69954C2 6.47732 2.07733 6.28288 2.232 6.11621C2.38667 5.94954 2.576 5.86621 2.8 5.86621H17.2C17.424 5.86621 17.6133 5.94954 17.768 6.11621C17.9227 6.28288 18 6.47732 18 6.69954V18.3662C18 18.5995 17.9227 18.7995 17.768 18.9662C17.6133 19.1329 17.424 19.2107 17.2 19.1995H5.568ZM9.2 15.0329H10.8V16.6995H9.2V15.0329ZM7.248 10.7162C7.33333 10.2718 7.50933 9.87177 7.776 9.51621C8.04267 9.16066 8.368 8.8801 8.752 8.67454C9.136 8.46899 9.552 8.36621 10 8.36621C10.512 8.37732 10.9813 8.51343 11.408 8.77454C11.8347 9.03566 12.1733 9.38843 12.424 9.83288C12.6747 10.2773 12.8 10.7634 12.8 11.2912C12.8 11.819 12.6747 12.3051 12.424 12.7495C12.1733 13.194 11.8347 13.5495 11.408 13.8162C10.9813 14.0829 10.512 14.2162 10 14.2162H9.2V12.5329H10C10.3307 12.5329 10.6133 12.4134 10.848 12.1745C11.0827 11.9357 11.2 11.6412 11.2 11.2912C11.2 10.9412 11.0827 10.6468 10.848 10.4079C10.6133 10.169 10.3307 10.0495 10 10.0495C9.712 10.0495 9.45867 10.144 9.24 10.3329C9.02133 10.5218 8.88 10.7607 8.816 11.0495L7.248 10.7162Z"
      fill="#2563EB"
    />
  </svg>
);

export const QuizCard2 = () => (
  <svg
    width="20"
    height="28"
    viewBox="0 0 20 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5219 5.66634C15.7459 5.66634 15.9352 5.7469 16.0899 5.90801C16.2445 6.06912 16.3219 6.26634 16.3219 6.49968V9.63301L14.7219 11.2997V7.33301H3.52188V20.6663H14.7219V18.3663L16.3219 16.6997V21.4997C16.3219 21.733 16.2445 21.9302 16.0899 22.0913C15.9352 22.2525 15.7459 22.333 15.5219 22.333H2.72188C2.49788 22.333 2.30854 22.2525 2.15388 22.0913C1.99921 21.9302 1.92188 21.733 1.92188 21.4997V6.49968C1.92188 6.26634 1.99921 6.06912 2.15388 5.90801C2.30854 5.7469 2.49788 5.66634 2.72188 5.66634H15.5219ZM16.9459 11.333L18.0819 12.5163L11.8579 18.9997H10.7219V17.8163L16.9459 11.333ZM9.92188 13.9997V15.6663H5.92188V13.9997H9.92188ZM12.3219 10.6663V12.333H5.92188V10.6663H12.3219Z"
      fill="#EA580C"
    />
  </svg>
);

export const QuizCard3 = () => (
  <svg
    width="20"
    height="28"
    viewBox="0 0 20 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.60156 6.91667V5.25H7.20156V6.91667H12.0016V5.25H13.6016V6.91667H16.8016C17.0256 6.91667 17.2149 6.99722 17.3696 7.15833C17.5242 7.31944 17.6016 7.51667 17.6016 7.75V11.9167H16.0016V8.58333H13.6016V10.25H12.0016V8.58333H7.20156V10.25H5.60156V8.58333H3.20156V20.25H8.00156V21.9167H2.40156C2.17756 21.9167 1.98823 21.8361 1.83356 21.675C1.6789 21.5139 1.60156 21.3167 1.60156 21.0833V7.75C1.60156 7.51667 1.6789 7.31944 1.83356 7.15833C1.98823 6.99722 2.17756 6.91667 2.40156 6.91667H5.60156ZM13.6016 14.4167C13.0256 14.4167 12.4922 14.5667 12.0016 14.8667C11.5109 15.1667 11.1216 15.5722 10.8336 16.0833C10.5456 16.5944 10.4016 17.15 10.4016 17.75C10.4016 18.35 10.5456 18.9056 10.8336 19.4167C11.1216 19.9278 11.5109 20.3333 12.0016 20.6333C12.4922 20.9333 13.0256 21.0833 13.6016 21.0833C14.1776 21.0833 14.7109 20.9333 15.2016 20.6333C15.6922 20.3333 16.0816 19.9278 16.3696 19.4167C16.6576 18.9056 16.8016 18.35 16.8016 17.75C16.8016 17.15 16.6576 16.5944 16.3696 16.0833C16.0816 15.5722 15.6922 15.1667 15.2016 14.8667C14.7109 14.5667 14.1776 14.4167 13.6016 14.4167ZM8.80156 17.75C8.80156 16.85 9.02023 16.0111 9.45756 15.2333C9.88423 14.4778 10.4602 13.8778 11.1856 13.4333C11.9322 12.9778 12.7376 12.75 13.6016 12.75C14.4656 12.75 15.2709 12.9778 16.0176 13.4333C16.7429 13.8778 17.3189 14.4778 17.7456 15.2333C18.1829 16.0111 18.4016 16.85 18.4016 17.75C18.4016 18.65 18.1829 19.4889 17.7456 20.2667C17.3189 21.0222 16.7429 21.6222 16.0176 22.0667C15.2709 22.5222 14.4656 22.75 13.6016 22.75C12.7376 22.75 11.9322 22.5222 11.1856 22.0667C10.4602 21.6222 9.88423 21.0222 9.45756 20.2667C9.02023 19.4889 8.80156 18.65 8.80156 17.75ZM12.8016 15.25V18.1L14.6416 20L15.7616 18.8333L14.4016 17.4V15.25H12.8016Z"
      fill="#16A34A"
    />
  </svg>
);

export const QuizCard4 = () => (
  <svg
    width="20"
    height="28"
    viewBox="0 0 20 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8031 18.1167V19.8333H14.8031V21.5H5.20312V19.8333H9.20312V18.1167C8.15779 17.9833 7.20846 17.6056 6.35513 16.9833C5.50179 16.3611 4.83513 15.5778 4.35513 14.6333C3.85379 13.6556 3.60313 12.6111 3.60313 11.5V6.5H16.4031V11.5C16.4031 12.6111 16.1525 13.6556 15.6511 14.6333C15.1711 15.5778 14.5045 16.3611 13.6511 16.9833C12.7978 17.6056 11.8485 17.9833 10.8031 18.1167ZM5.20312 8.16667V11.5C5.20312 12.4 5.42179 13.2389 5.85913 14.0167C6.28579 14.7722 6.86179 15.3722 7.58713 15.8167C8.33379 16.2722 9.13913 16.5 10.0031 16.5C10.8671 16.5 11.6725 16.2722 12.4191 15.8167C13.1445 15.3722 13.7205 14.7722 14.1471 14.0167C14.5845 13.2389 14.8031 12.4 14.8031 11.5V8.16667H5.20312ZM1.20312 8.16667H2.80313V11.5H1.20312V8.16667ZM17.2031 8.16667H18.8031V11.5H17.2031V8.16667Z"
      fill="#089BC4"
    />
  </svg>
);

export const WeeklyRecurring = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.13573 25.3333L10.2691 26.4666C10.5357 26.7333 10.6637 27.0444 10.6531 27.4C10.6424 27.7555 10.5144 28.0666 10.2691 28.3333C10.0024 28.6 9.68595 28.7391 9.31973 28.7506C8.95351 28.7622 8.63662 28.6342 8.36906 28.3666L4.93573 24.9333C4.80239 24.8 4.70773 24.6555 4.65173 24.5C4.59573 24.3444 4.56862 24.1777 4.57039 24C4.57217 23.8222 4.60017 23.6555 4.65439 23.5C4.70862 23.3444 4.80284 23.2 4.93706 23.0666L8.37039 19.6333C8.63706 19.3666 8.95395 19.2391 9.32106 19.2506C9.68817 19.2622 10.0046 19.4008 10.2704 19.6666C10.5148 19.9333 10.6428 20.2444 10.6544 20.6C10.6659 20.9555 10.538 21.2666 10.2704 21.5333L9.13706 22.6666H22.6691V18.6666C22.6691 18.2888 22.7971 17.9724 23.0531 17.7173C23.3091 17.4622 23.6255 17.3342 24.0024 17.3333C24.3793 17.3324 24.6962 17.4604 24.9531 17.7173C25.2099 17.9742 25.3375 18.2906 25.3357 18.6666V22.6666C25.3357 23.4 25.0748 24.028 24.5531 24.5506C24.0313 25.0733 23.4033 25.3342 22.6691 25.3333H9.13573ZM22.8691 9.33329H9.33573V13.3333C9.33573 13.7111 9.20773 14.028 8.95173 14.284C8.69573 14.54 8.37928 14.6675 8.00239 14.6666C7.62551 14.6657 7.30906 14.5377 7.05306 14.2826C6.79706 14.0275 6.66906 13.7111 6.66906 13.3333V9.33329C6.66906 8.59995 6.93039 7.9724 7.45306 7.45062C7.97573 6.92884 8.60328 6.66751 9.33573 6.66662H22.8691L21.7357 5.53328C21.4691 5.26662 21.3411 4.95551 21.3517 4.59995C21.3624 4.2444 21.4904 3.93328 21.7357 3.66662C22.0024 3.39995 22.3188 3.26128 22.6851 3.25062C23.0513 3.23995 23.3682 3.36751 23.6357 3.63328L27.0691 7.06662C27.2024 7.19995 27.2971 7.3444 27.3531 7.49995C27.4091 7.65551 27.4366 7.82217 27.4357 7.99995C27.4348 8.17773 27.4073 8.3444 27.3531 8.49995C27.2988 8.65551 27.2042 8.79995 27.0691 8.93328L23.6357 12.3666C23.3691 12.6333 23.0526 12.7613 22.6864 12.7506C22.3202 12.74 22.0033 12.6008 21.7357 12.3333C21.4913 12.0666 21.3633 11.7555 21.3517 11.4C21.3402 11.0444 21.4682 10.7333 21.7357 10.4666L22.8691 9.33329Z"
      fill="#2B2B2B"
    />
  </svg>
);

export const EditSession = () => (
  <svg
    width="41"
    height="37"
    viewBox="0 0 41 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.2565 4.86942C26.8134 4.31273 27.5685 4 28.3559 4C29.1433 4 29.8984 4.31273 30.4552 4.86942L34.1299 8.54414C34.4057 8.8199 34.6246 9.14731 34.7739 9.50766C34.9232 9.86801 35 10.2542 35 10.6443C35 11.0344 34.9232 11.4206 34.7739 11.7809C34.6246 12.1413 34.4057 12.4687 34.1299 12.7445L16.4724 30.4024L7 32L8.59902 22.5274L26.2565 4.86942ZM25.9165 9.40826L29.5911 13.083L32.0305 10.6436L28.3559 6.97032L25.9165 9.40826ZM27.4903 15.1839L23.8172 11.5092L11.3695 23.9572L10.6227 28.3772L15.0426 27.6319L27.4903 15.1839Z"
      fill="#A1A1A1"
    />
  </svg>
);

export const DeleteSession = () => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0546 34.125C10.2746 34.125 9.61071 33.8494 9.06286 33.2982C8.515 32.747 8.24107 32.0795 8.24107 31.2959V9.60059H6.5V7.84884H13.4643V6.5H23.9107V7.84884H30.875V9.60059H29.1339V31.2959C29.1339 32.1017 28.8658 32.775 28.3296 33.3157C27.7933 33.8564 27.1236 34.1262 26.3204 34.125H11.0546ZM27.3929 9.60059H9.98214V31.2959C9.98214 31.6101 10.0825 31.8682 10.2833 32.0702C10.4842 32.2722 10.7413 32.3733 11.0546 32.3733H26.3221C26.5891 32.3733 26.8346 32.2611 27.0586 32.0369C27.2826 31.8127 27.394 31.5651 27.3929 31.2942V9.60059ZM14.8711 28.8698H16.6121V13.1041H14.8711V28.8698ZM20.7629 28.8698H22.5039V13.1041H20.7629V28.8698Z"
      fill="#EF4444"
    />
  </svg>
);
